import { defineComponent as _defineComponent } from 'vue'
import IconLogout from '@/icons/icon-logout.vue';
  import { useAuthStore } from '@/stores/authStore';
  import { ref } from 'vue';
  import { useRouter } from 'vue-router';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardNavbarDesktop',
  setup(__props, { expose: __expose }) {
  __expose();

  const authStore = useAuthStore();
  const router = useRouter();
  const appr = ref('');
  const doAprr = () => {
    appr.value = 'appear';
  };
  const unAppear = () => {
    appr.value = '';
  };
  const logout = () => {
    authStore.logout();
    router.replace({ name: 'Home' });
  };

const __returned__ = { authStore, router, appr, doAprr, unAppear, logout, IconLogout, get useAuthStore() { return useAuthStore }, ref, get useRouter() { return useRouter } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})